import { ListBullets } from "@phosphor-icons/react";
import CollapsibleSection from "@/components/admin/CollapsibleSection";

function fmtDate(iso) {
  try {
    const d = new Date(iso);
    return d.toLocaleString("en-US", { dateStyle: "medium", timeStyle: "short" });
  } catch {
    return iso;
  }
}

export default function LeadsTable({ leads, onRefresh, defaultOpen = true }) {
  return (
    <CollapsibleSection
      id="leads-table"
      testId="admin-leads-table"
      title={<><ListBullets size={18} weight="fill" className="text-[#FF1B91] inline mr-2" />All leads</>}
      subtitle={leads ? `Showing ${leads.count} of ${leads.total}` : "Loading…"}
      onRefresh={onRefresh}
      defaultOpen={defaultOpen}
    >
      {!leads ? (
        <div className="text-white/50 text-sm">No leads loaded.</div>
      ) : (
        <div className="overflow-x-auto border border-white/10">
          <table className="w-full text-sm">
            <thead className="bg-[#0F0F0F]">
              <tr className="text-left text-[10px] uppercase tracking-[0.2em] text-[#FF1B91] font-bold">
                <th className="px-4 py-3">When</th>
                <th className="px-4 py-3">Name / Email</th>
                <th className="px-4 py-3">Location</th>
                <th className="px-4 py-3">IP / ISP</th>
                <th className="px-4 py-3">Source</th>
              </tr>
            </thead>
            <tbody>
              {leads.leads?.map((l) => (
                <tr key={l.id} className="border-t border-white/5 hover:bg-white/[0.02]">
                  <td className="px-4 py-3 text-white/65 text-xs whitespace-nowrap">{fmtDate(l.created_at)}</td>
                  <td className="px-4 py-3">
                    <div className="font-semibold">{l.name || <span className="text-white/40">—</span>}</div>
                    <a href={`mailto:${l.email}`} className="text-[#FF1B91] text-xs hover:underline">{l.email}</a>
                  </td>
                  <td className="px-4 py-3 text-white/70 text-xs">
                    {l.city ? <>{l.city}{l.region && `, ${l.region}`}<br/><span className="text-white/40">{l.country}</span></> : <span className="text-white/30">—</span>}
                  </td>
                  <td className="px-4 py-3 text-xs">
                    <code className="text-white/65">{l.ip || "—"}</code>
                    <div className="text-white/35 text-[11px]">{l.isp}</div>
                  </td>
                  <td className="px-4 py-3 text-white/65 text-xs">
                    {l.source}
                    {l.referrer && <div className="text-white/35 text-[11px] truncate max-w-[160px]">↑ {l.referrer}</div>}
                  </td>
                </tr>
              ))}
              {leads.leads?.length === 0 && (
                <tr><td colSpan="5" className="px-4 py-10 text-center text-white/40">No leads yet. They&apos;ll show here the moment someone submits the Pink Plan form.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </CollapsibleSection>
  );
}
